<template>
  <v-container fluid class="pa-5">
    <!-- Encabezado -->
    <v-sheet
      class="pa-4 mb-4 d-flex align-center justify-space-between flex-wrap ga-2"
      color="#194c9b"
      rounded
      elevation="2"
    >
      <div class="d-flex align-center ga-2">
        <v-icon color="white">mdi-office-building-outline</v-icon>
        <h1 class="text-h5 font-weight-bold text-white">
          Usuarios por Unidad de Negocio
        </h1>
      </div>
    </v-sheet>

    <!-- Tabla de unidades -->
    <v-card rounded="lg" variant="outlined">
      <v-data-table
        :headers="headers"
        :items="unidades"
        :loading="loading"
        item-value="unidad"
        no-data-text="No hay unidades de negocio"
        loading-text="Cargando..."
      >
       <!-- // v-slot  directiva para pasar contrenido html o plantillas-->
        <template #item.usuariosCount="{ item }">
          <v-chip size="small" variant="tonal" color="primary">
            {{ usuariosDe(item).length }}
          </v-chip>
        </template>

        <template #item.actions="{ item }">
          <v-btn
            color="primary"
            variant="tonal"
            size="small"
            prepend-icon="mdi-account-group"
            @click="abrirUsuarios(item)"
          >
            Ver usuarios
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal: usuarios de la unidad seleccionada -->
    <v-dialog v-model="modal" max-width="820">
      <v-card rounded="lg">
        <v-card-title
          class="d-flex align-center justify-space-between text-subtitle-1 font-weight-bold"
        >
          <span>Usuarios · {{ unidadSel?.unidad_nombre ?? "" }}</span>
          <v-btn icon variant="text" @click="modal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />

        <v-card-text>
          <v-data-table
            :headers="headersUsuarios"
            :items="modalUsuarios"
            item-value="id"
            density="compact"
            no-data-text="Esta unidad no tiene usuarios"
            hide-default-footer
            :items-per-page="-1"
          >
            <template #item.nuevaUnidad="{ item }">
              <v-select
                v-model="item.nuevaUnidad"
                :items="opcionesUnidades"
                item-title="title"
                item-value="value"
                variant="outlined"
                density="compact"
                hide-details
                style="min-width: 220px"
              />
            </template>

            <template #item.accion="{ item }">
              <v-btn
                color="success"
                variant="elevated"
                size="small"
                :disabled="item.nuevaUnidad === item.unidadActual"
                :loading="savingUserId === item.id"
                @click="guardarUnidad(item)"
              >
                Guardar
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider />
        <v-card-actions class="justify-end">
          <v-btn variant="text" @click="modal = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { swal } from "@/utils/swal";

import { useSettingsStore } from "@/stores/settings";
import { getUserForUnit, getUnidades,saveUnitForUser } from "@/api/unidadesNegocio.js";

export default {
  name: "UserUnidadNegocio",
  data() {
    return {
      unidades: [],
      allUnidades: [],
      loading: false,
      // Modal
      modal: false,
      unidadSel: null,
      modalUsuarios: [],
      savingUserId: null,
      headers: [
        { title: "ID", key: "unidad", width: 90 },
        { title: "Unidad de negocio", key: "unidad_nombre", width:120 },
        {
          title: "Cantidad de Usuarios",
          key: "usuariosCount",
          sortable: false,
          width: 120,
        },
        {
          title: "Acciones",
          key: "actions",
          sortable: false,
          align: "end",
          width: 120,
        },
      ],
      headersUsuarios: [
        { title: "Usuario", key: "nombre" },
        { title: "Correo", key: "email" },
        { title: "Unidad", key: "nuevaUnidad", sortable: false },
        { title: "", key: "accion", sortable: false, align: "end", width: 120 },
      ],
    };
  },
  computed: {
    isDark() {
      return useSettingsStore().theme === "dark";
    },
    opcionesUnidades() {
      return (this.allUnidades || []).map((u) => ({
        title: u.nameUnitBussines,
        value: u.id,
      }));
    },
  },
  mounted() {
    this.cargar();
  },
  methods: {
    popupClass() {
      return {
        popup: this.isDark ? "mi-popup" : "mi-popup-2",
        title: "mi-titulo",
      };
    },
    // Usuarios de una unidad (tolerante al nombre del campo).
    usuariosDe(item) {
      return item.usuarios ?? item.users ?? item.miembros ?? [];
    },
    async cargar() {
      this.loading = true;
      try {
        const [unidades, todas] = await Promise.all([
          getUserForUnit(),
          getUnidades(),
        ]);
        this.unidades = Array.isArray(unidades)
          ? unidades
          : unidades?.results ?? [];
        this.allUnidades = Array.isArray(todas) ? todas : todas?.results ?? [];
        console.log("Usuarios por unidad →", this.unidades);
      } catch (e) {
        console.error(e);
        this.unidades = [];
      } finally {
        this.loading = false;
      }
    },
    abrirUsuarios(unidad) {
      this.unidadSel = unidad;
      // El id de la unidad viene en "unidad" (no "id") en este endpoint.
      const unidadId = unidad.unidad ?? unidad.id;
      this.modalUsuarios = this.usuariosDe(unidad).map((u) => ({
        id: u.id,
        nombre:
          `${u.first_name ?? ""} ${u.last_name ?? ""}`.trim() ||
          u.username ||
          `#${u.id}`,
        email: u.email ?? "",
        unidadActual: unidadId,
        nuevaUnidad: unidadId,
      }));
      this.modal = true;
    },
    async guardarUnidad(user) {
      this.savingUserId = user.id;
      try {
        await saveUnitForUser(user);

        // 1) Recargamos las unidades con sus usuarios (esperando a que termine).
        await this.cargar();

        // 2) Refrescamos el modal con la unidad abierta: el usuario que cambio
        //    de unidad ya no aparece aqui (se fue a otra).
        if (this.unidadSel) {
          const idAbierta = this.unidadSel.unidad ?? this.unidadSel.id;
          const actualizada = this.unidades.find(
            (u) => (u.unidad ?? u.id) === idAbierta,
          );
          if (actualizada) {
            this.abrirUsuarios(actualizada);
          } else {
            this.modal = false; // la unidad ya no esta en la lista
          }
        }

        await swal({
          icon: "success",
          title: "Unidad Asignada con éxito",
          timer: 1800,
          showConfirmButton: false,
          customClass: this.popupClass(),
        });
      } catch (error) {
        console.error(error);
        await swal({
          icon: "error",
          title: "Error",
          text: "No se pudo guardar la unidad.",
          customClass: this.popupClass(),
        });
      } finally {
        this.savingUserId = null;
      }
    },
  },
};
</script>
